import React, { useState } from 'react';
import {
    IoAdd,
    IoRemove,
    IoHelpCircle,
    IoChevronDown,
    IoChevronUp,
} from 'react-icons/io5';
import styles from '../AddProduct.module.css';

function ProductFAQ({
    faqs,
    setFaqs,
    errorFields,
    setErrorFields,
    handleFieldChange,
}) {
    const [newQuestion, setNewQuestion] = useState('');
    const [newAnswer, setNewAnswer] = useState('');
    const [expandedIndex, setExpandedIndex] = useState(null);

    const addFAQ = () => {
        if (newQuestion.trim() && newAnswer.trim()) {
            const newFAQ = {
                id: Date.now(),
                question: newQuestion.trim(),
                answer: newAnswer.trim(),
            };
            setFaqs([...faqs, newFAQ]);
            setNewQuestion('');
            setNewAnswer('');
        }
    };

    const removeFAQ = (index) => {
        const updatedFaqs = faqs.filter((_, i) => i !== index);
        setFaqs(updatedFaqs);
    };

    const updateFAQ = (index, field, value) => {
        const updatedFaqs = [...faqs];
        updatedFaqs[index][field] = value;
        setFaqs(updatedFaqs);
    };

    const toggleExpanded = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <div className={styles['AddProduct-card']}>
            <div className={styles['AddProduct-card-header']}>
                <div className={styles['AddProduct-card-title']}>
                    <IoHelpCircle className={styles['AddProduct-card-icon']} />
                    <span>Product FAQ</span>
                </div>
                <div className={styles['AddProduct-card-subtitle']}>
                    Add frequently asked questions for better SEO and user
                    experience
                </div>
            </div>

            <div className={styles['faq-container']}>
                {/* Add New FAQ */}
                <div className={styles['faq-add-section']}>
                    <div className={styles['faq-add-header']}>
                        <h4>Add New FAQ</h4>
                        <p>
                            FAQs help with SEO and reduce customer support
                            queries
                        </p>
                    </div>

                    <div className={styles['faq-add-form']}>
                        <div className={styles['faq-input-group']}>
                            <label className={styles['faq-label']}>
                                Question *
                            </label>
                            <input
                                type="text"
                                value={newQuestion}
                                onChange={(e) => setNewQuestion(e.target.value)}
                                placeholder="e.g., What is the warranty period?"
                                className={styles['faq-input']}
                                maxLength={200}
                            />
                            <div className={styles['faq-char-count']}>
                                {newQuestion.length}/200 characters
                            </div>
                        </div>

                        <div className={styles['faq-input-group']}>
                            <label className={styles['faq-label']}>
                                Answer *
                            </label>
                            <textarea
                                value={newAnswer}
                                onChange={(e) => setNewAnswer(e.target.value)}
                                placeholder="e.g., This product comes with a 1-year manufacturer warranty..."
                                className={styles['faq-textarea']}
                                rows={3}
                                maxLength={500}
                            />
                            <div className={styles['faq-char-count']}>
                                {newAnswer.length}/500 characters
                            </div>
                        </div>

                        <button
                            onClick={addFAQ}
                            disabled={!newQuestion.trim() || !newAnswer.trim()}
                            className={styles['faq-add-button']}
                            type="button"
                        >
                            <IoAdd />
                            Add FAQ
                        </button>
                    </div>
                </div>

                {/* Existing FAQs */}
                {faqs.length > 0 && (
                    <div className={styles['faq-list-section']}>
                        <div className={styles['faq-list-header']}>
                            <h4>Product FAQs ({faqs.length})</h4>
                            <p>Click to expand and edit FAQ items</p>
                        </div>

                        <div className={styles['faq-list']}>
                            {faqs.map((faq, index) => (
                                <div
                                    key={faq.id}
                                    className={styles['faq-item']}
                                >
                                    <div
                                        className={styles['faq-item-header']}
                                        onClick={() => toggleExpanded(index)}
                                    >
                                        <div className={styles['faq-question']}>
                                            <span
                                                className={styles['faq-number']}
                                            >
                                                Q{index + 1}:
                                            </span>
                                            {faq.question}
                                        </div>
                                        <div className={styles['faq-actions']}>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    removeFAQ(index);
                                                }}
                                                className={
                                                    styles['faq-remove-button']
                                                }
                                                type="button"
                                                title="Remove FAQ"
                                            >
                                                <IoRemove />
                                            </button>
                                            {expandedIndex === index ? (
                                                <IoChevronUp
                                                    className={
                                                        styles[
                                                            'faq-expand-icon'
                                                        ]
                                                    }
                                                />
                                            ) : (
                                                <IoChevronDown
                                                    className={
                                                        styles[
                                                            'faq-expand-icon'
                                                        ]
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {expandedIndex === index && (
                                        <div
                                            className={
                                                styles['faq-item-content']
                                            }
                                        >
                                            <div
                                                className={
                                                    styles['faq-edit-group']
                                                }
                                            >
                                                <label
                                                    className={
                                                        styles['faq-edit-label']
                                                    }
                                                >
                                                    Question
                                                </label>
                                                <input
                                                    type="text"
                                                    value={faq.question}
                                                    onChange={(e) =>
                                                        updateFAQ(
                                                            index,
                                                            'question',
                                                            e.target.value
                                                        )
                                                    }
                                                    className={
                                                        styles['faq-edit-input']
                                                    }
                                                    maxLength={200}
                                                />
                                            </div>

                                            <div
                                                className={
                                                    styles['faq-edit-group']
                                                }
                                            >
                                                <label
                                                    className={
                                                        styles['faq-edit-label']
                                                    }
                                                >
                                                    Answer
                                                </label>
                                                <textarea
                                                    value={faq.answer}
                                                    onChange={(e) =>
                                                        updateFAQ(
                                                            index,
                                                            'answer',
                                                            e.target.value
                                                        )
                                                    }
                                                    className={
                                                        styles[
                                                            'faq-edit-textarea'
                                                        ]
                                                    }
                                                    rows={3}
                                                    maxLength={500}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* FAQ Tips */}
                <div className={styles['faq-tips']}>
                    <h4>FAQ Best Practices</h4>
                    <ul>
                        <li>
                            Use natural language that customers would actually
                            ask
                        </li>
                        <li>
                            Include relevant keywords in questions and answers
                        </li>
                        <li>Keep answers concise but informative</li>
                        <li>
                            Focus on common concerns about shipping, returns,
                            and product details
                        </li>
                        <li>Update FAQs based on customer support queries</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default ProductFAQ;
